export default {};

export const exportJobsLabels = {
  jobNr: 'Job #',
  startDate: 'Date Opened',
  closed: 'Date Completed',
  name: 'Customer',
  address: 'Cust Address 1',
  townSuburb: 'Cust Town',
  state: 'Cust State',
  postcode: 'Cust Postcode',
  email: 'Cust Email',
  product: 'Product',
  product2: 'Product 2',
  status: 'Status',
  priority: 'Priority',
  clientRef: 'Client Ref',
  serviceAgent: 'Service Agent',
  faultInformation: 'Fault Type',
  description: 'Fault Info',
  parts: 'Parts Ordered',
  datePurchased: 'Date of Purchase',
  purchasedFrom: 'Purchased From',
  finalKpa: 'Final KPA',
  // clientAmount: 'Total Client $',
};
